const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SESSION_KEY = 'davocado_session_id';
const TRACK_CACHE_KEY = 'davocado_track_cache';
const DEBOUNCE_MS = 30000;

function getSessionId() {
  let sessionId = sessionStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }
  return sessionId;
}

function getTrackCache() {
  try {
    const raw = sessionStorage.getItem(TRACK_CACHE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function setTrackCache(cache) {
  try {
    sessionStorage.setItem(TRACK_CACHE_KEY, JSON.stringify(cache));
  } catch {}
}

function shouldTrack(page) {
  const cache = getTrackCache();
  const lastTracked = cache[page];
  if (lastTracked && Date.now() - lastTracked < DEBOUNCE_MS) {
    return false;
  }
  cache[page] = Date.now();
  setTrackCache(cache);
  return true;
}

function sendEvent(data) {
  const payload = JSON.stringify({
    ...data,
    session_id: getSessionId(),
    screen_width: window.innerWidth,
    referrer: document.referrer || null,
    user_agent: navigator.userAgent,
    created_at: new Date().toISOString(),
  });

  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([payload], { type: 'application/json' });
      navigator.sendBeacon(`${API}/analytics/track`, blob);
    } else {
      fetch(`${API}/analytics/track`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
        keepalive: true,
      }).catch(() => {});
    }
  } catch {}
}

export function trackPageView(page, pageTitle, extraData = {}) {
  if (!shouldTrack(page)) return;
  sendEvent({
    event_type: 'page_view',
    page,
    page_title: pageTitle,
    ...extraData,
  });
}

export function trackProductView(page, productId, productName, productCategory) {
  const key = `product:${productId}`;
  if (!shouldTrack(key)) return;
  sendEvent({
    event_type: 'product_view',
    page,
    page_title: productName,
    product_id: productId,
    product_name: productName,
    product_category: productCategory || null,
  });
}
